export const txtSaveTheDateTitle = {
  id: "Catat tanggalnya ya!",
  en: "Save the date!",
};

export const txtDatePlaceholder = {
  id: "Hari",
  en: "Day",
};

export const txtHourPlaceholder = {
  id: "Jam",
  en: "Hour",
};

export const txtMinutePlaceholder = {
  id: "Menit",
  en: "Minute",
};

export const txtSecondPlaceholder = {
  id: "Detik",
  en: "Second",
};
